module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-400-regular-italic-c60e742892f35d0e53e48aa54d64c28a.woff";